<template>
  <div>
    <input type="text" v-model="filter" class="form-control" placeholder="Search..." />

    <div v-for="(drugGroup, groupIterationIndex) in drugGroups" :key="drugGroup.name">
      <h3>
        <span class="form-group">
          <span @click="toggleGroup(groupIterationIndex)"> {{ drugGroup.name }} </span>
          <comments :field-name="`heading_${slugify(drugGroup.name)}`"></comments>
        </span>
      </h3>


      <div class="alert alert-warning" v-if="filteredDrugs(drugGroup.drugs).length <= 0">
        No Results Found
      </div>
      <div v-for="(drug, drugIterationIndex) in filteredDrugs(drugGroup.drugs)" :key="drug.pk">
        <div
          class="clearfix drug_group"
          :class="{ show: shouldShowGroup(groupIterationIndex), hide: !shouldShowGroup(groupIterationIndex) }"
          :style="{ width: 400 + totalAnimals * 400 + 'px' }"
        >
          <div v-if="drug.inactive == false">
            <div class="farm-fields">
              <h4 v-if="drugIterationIndex == 0">Qty Used Last Year</h4>
              <div class="form-group">
                <label> {{ drug.drug_name }} <br/>  {{ `Allocate ${drug.doses_per_sale_unit} doses per ${drug.sale_unit}` }}</label>

                <template v-if="lastYearUsage && Object.keys(lastYearUsage).length > 0">
                  <input type="number" :value="lastYearUsage[drug.pk]" class="form-control" disabled />
                </template>
                <template v-else>
                  <input type="number" class="form-control" disabled />
                </template>
              </div>
            </div>

            <div
              v-for="(gfAnimal, animalIterationIndex) in enabledAnimals(animalType)"
              :key="`animal_${animalIterationIndex}`"
              class="farm-fields"
            >
              <h4 v-if="drugIterationIndex == 0">{{ gfAnimal.name }}</h4>

              <div class="row" v-if="Object.keys(getPreAllocation(drug.pk, gfAnimal.id)).length > 0">
                <p style="margin-bottom: 5px">
                  <strong>
                    {{ drug.drug_name }} <br/>
                  </strong>
                </p>
                <div class="col-md-6" :disabled="drug.inactive || drug.disallow_allocations">
                  <number-input
                    :show-label="false"
                    :show-input-box="false"
                    :field-name="`pre_allocation_animal_${gfAnimal.id}_drug_${drug.pk}-par_qty`"
                    :disabled="drug.inactive || drug.disallow_allocations"
                    vvalidate="min_value:0"
                    modelName="DrugAllocations"
                  >
                  </number-input>
                  <span class="text-danger">
                    Expires {{ $moment(getPreAllocation(drug.pk, gfAnimal.id)['par_end_date']).format('DD-MM-YYYY') }}
                  </span>
                </div>

                <div class="col-md-6" :disabled="drug.inactive || drug.disallow_allocations">
                  <number-input
                    :show-label="false"
                    :show-input-box="false"
                    :field-name="`animal_${gfAnimal.id}_drug_${drug.pk}-par_qty`"
                    :disabled="drug.inactive || drug.disallow_allocations"
                    vvalidate="min_value:0"
                    modelName="DrugAllocations"
                  >
                  </number-input>
                  <span class="text-danger">
                    {{ getExpirationDate($moment(getPreAllocation(drug.pk, gfAnimal.id)['par_end_date'])) }}
                  </span>
                </div>
              </div>
              <div v-else>
                <div class="form-group" :disabled="drug.inactive || drug.disallow_allocations">
                  <number-input
                    :show-input-box="false"
                    :field-name="`animal_${gfAnimal.id}_drug_${drug.pk}-par_qty`"
                    :label="drug.drug_name"
                    :disabled="drug.inactive || drug.disallow_allocations"
                    vvalidate="min_value:0"
                    modelName="DrugAllocations"
                  >
                  </number-input>
                </div>
              </div>
            </div>

            <div
              v-for="(gfNewAnimal, newAnimalIterationIndex) in newAnimals(animalType)"
              :key="`new_animal_${newAnimalIterationIndex}`"
              class="farm-fields"
            >
              <h4 v-if="drugIterationIndex == 0">{{ gfNewAnimal.name }}</h4>

              <div class="form-group" :disabled="drug.inactive || drug.disallow_allocations">
                <number-input
                  :show-input-box="false"
                  :field-name="`new_animal_${gfNewAnimal.frontend_id}_drug_${drug.pk}-par_qty`"
                  :label="`${drug.drug_name} - (${drug.doses_per_sale_unit} Doses per sale unit)`"
                  :disabled="drug.inactive || drug.disallow_allocations"
                  modelName="DrugAllocations"
                  vvalidate="min_value:0"
                >
                </number-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { slugify } from '../../_helpers'
import { mapGetters } from 'vuex'
import NumberInput from '@/components/inputs/NumberInput'
import Comments from '@/components/Comments'

// TODO: refactor to receive only animal type, we can get everything from vuex ;)
export default {
  name: 'DrugAllocationInputs',
  props: {
    animalType: String,
    drugGroups: Array,
    lastYearUsage: Object,
  },
  components: {
    NumberInput,
    Comments,
  },
  data() {
    return {
      filter: '',
      groupVisibility: {
        // TODO: use this.$set to avoid this ugly thing
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false,
        16: false,
        17: false,
        18: false,
        19: false,
        20: false,
      },
    }
  },
  methods: {
    slugify: function (text) {
      return slugify(text)
    },
    toggleGroup: function (groupIndex) {
      this.groupVisibility[groupIndex] = !this.groupVisibility[groupIndex]
    },
    shouldShowGroup: function (groupIndex) {
      return this.searching || Boolean(this.groupVisibility[groupIndex])
    },
    filteredDrugs: function (drugs) {
      if (this.filter) {
        let filteredDrugs = []
        for (const drug of drugs) {
          if (drug.drug_name.toLowerCase().includes(this.filter.toLowerCase().trim())) {
            filteredDrugs.push(drug)
          }
        }
        return filteredDrugs
      } else {
        return drugs
      }
    },
    getExpirationDate: function (preAllocationEndDate) {
      let today = this.$moment()

      if (today < preAllocationEndDate) {
        let futureAllocationStartDate = this.$moment(preAllocationEndDate).add('1', 'days').format('DD-MM-YYYY')

        let futureAllocationEndDate = today
          .add(this.$moment(preAllocationEndDate).year() - today.year() + 1, 'years')
          .format('DD-MM-YYYY')

        return `${futureAllocationStartDate} / ${futureAllocationEndDate}`
      }
      return today.format('DD-MM-YYYY') + ' / ' + today.add('1', 'years').format('DD-MM-YYYY')
    },
    getPreAllocation: function (drugId, animalId) {
      let model = this.$store.state.currentConsult.models.DrugAllocations

      let preAllocation = Object.keys(model)
        .filter((key) => key.startsWith(`pre_allocation_animal_${animalId}_drug_${drugId}-`))
        .reduce((obj, key) => {
          let newKey = key.split('-')[1]
          obj[newKey] = model[key]
          return obj
        }, {})
      return preAllocation
    },
  },
  computed: {
    ...mapGetters('currentConsult', ['isReadOnly', 'animals', 'newAnimals', 'enabledAnimals']),
    totalAnimals: function () {
      return Object.keys(this.enabledAnimals(this.animalType)).length
    },
    searching: function () {
      return this.filter
    },
  },
}
</script>

<style scoped>
.drug_group.show {
  display: block;
}
.drug_group.hide {
  display: none;
}
</style>
